import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { catchError, concatMap, Observable, throwError } from "rxjs";

import { CustomAuthService } from "../services/custom-auth.service";@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authSrv: CustomAuthService) {}

  private OWP_Error = "Configuration does not have the correct OWP access credentials";
  private excluded_urls = [
    "/oauth2/token",
    "authenticate/code",
    "authenticate/refresh",
    "assets/json",
    'localhost:2020'
  ];
  intercept(
    request: HttpRequest<LegacyAny>,
    next: HttpHandler
  ): Observable<HttpEvent<LegacyAny>> {
    const isExcluded = this.excluded_urls.some((subUrl) =>
      request.url.includes(subUrl)
    );
    const isLoggedIn = this.authSrv.isUserLoggedIn();
    const token = this.authSrv.getToken();

    const addBearer = () => {
      if (isLoggedIn && token  && !isExcluded) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    };


    const handleError = (error: HttpErrorResponse) => {
      const description = (error?.error as LegacyAny)?.description ?? (error as LegacyAny)?.description;
      if(error && error.status === 401 && token && description && !String(description).includes(this.OWP_Error)) {
            this.authSrv.handleTokenExpiry();
        }
      return throwError(() => error);
    }

    addBearer();
    if (this.authSrv.isRefreshing && !isExcluded) {
      return this.authSrv.onRefreshing.pipe(
        concatMap(() => {
          addBearer();
          return next.handle(request).pipe(
            catchError(handleError)
          );
        })
      );
    } else {
      return next.handle(request).pipe(catchError(handleError));
    }
  }
}

